import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FormBuilder, FormControl, Validators } from "@angular/forms";
import { ApiService } from 'src/app/services/http/api.service';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { BarcodeScanner } from '@ionic-native/barcode-scanner/ngx';
import { ToasterService } from 'src/app/services/toaster/toaster.service';
import { Router } from '@angular/router';
import { AnalyticsProvider } from 'providers/analytics/analytics';

@Component({
  selector: 'app-content-task-success-modal',
  templateUrl: './content-task-success-modal.page.html',
  styleUrls: ['./content-task-success-modal.page.scss'],
})
export class ContentTaskSuccessModalPage implements OnInit {
  points: any = "";

  constructor(
    private modalController: ModalController,
    private fb: FormBuilder,
    private apiService: ApiService,
    private toast: ToasterService,
    private apiConfig: ApiConfiguration,
    private analytics: AnalyticsProvider,
    private router: Router,


  ) { }

  ngOnInit() {


  }

  ionViewDidEnter() {
    this.analytics.trackScreen('ContentTaskSuccessModalPage')
  }

  closeModal(data) {

    this.modalController.dismiss("data")
  }


  onSubmit() {
    this.closeModal("datra")

  }

}